export const getDNColorName = (dnPercentage) => {
  const dn = parseFloat(dnPercentage);
  if (dn >= 85) return 'green';
  if (dn >= 70) return 'lime';
  if (dn >= 50) return 'yellow';
  if (dn >= 30) return 'orange';
  return 'red';
};